import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const COR_PINO = '#7C3AED';
const TITULO_PINO = 'Arraste até a porta';
const TEMPO_CARREGAR_GOOGLE_MS = 10000;

const iconePino = L.divIcon({
    className: 'taga-pino',
    html: `<div style="width:26px;height:26px;border-radius:50% 50% 50% 0;background:${COR_PINO};transform:rotate(-45deg);border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.4)"></div>`,
    iconSize: [26, 26],
    iconAnchor: [13, 26],
});

let carregandoGoogle = null;

export const chaveGoogleMaps = () => process.env.REACT_APP_GOOGLE_MAPS_KEY || '';

export const carregarGoogleMaps = (chave) => {
    if (window.google?.maps?.Map) return Promise.resolve(window.google.maps);
    if (carregandoGoogle) return carregandoGoogle;

    carregandoGoogle = new Promise((resolve, reject) => {
        const retorno = `__tagaGoogleMaps${Date.now()}`;
        const desistir = setTimeout(() => {
            delete window[retorno];
            reject(new Error('Google Maps não carregou a tempo'));
        }, TEMPO_CARREGAR_GOOGLE_MS);

        window[retorno] = () => {
            clearTimeout(desistir);
            delete window[retorno];
            resolve(window.google.maps);
        };

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(chave)}&language=pt-BR&region=BR&loading=async&callback=${retorno}`;
        script.async = true;
        script.onerror = () => {
            clearTimeout(desistir);
            delete window[retorno];
            reject(new Error('Google Maps não carregou'));
        };
        document.head.appendChild(script);
    }).catch((erro) => {
        carregandoGoogle = null;
        throw erro;
    });

    return carregandoGoogle;
};

export const criarMotorLeaflet = (no, { centro, zoom, aoClicar }) => {
    const mapa = L.map(no, {
        center: centro,
        zoom,
        zoomControl: false,
        dragging: false,
        scrollWheelZoom: false,
    });

    L.control.zoom({ position: 'bottomleft' }).addTo(mapa);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap',
    }).addTo(mapa);

    mapa.on('click', (e) => aoClicar(e.latlng.lat, e.latlng.lng));

    let marcador = null;

    return {
        tipo: 'leaflet',
        redimensionar: () => mapa.invalidateSize(),
        centralizar: (lat, lng, z, animar = true) => mapa.setView([lat, lng], z, { animate: animar }),
        zoom: () => mapa.getZoom(),
        arrasto: (solto) => {
            if (solto) { mapa.dragging.enable(); mapa.scrollWheelZoom.enable(); }
            else { mapa.dragging.disable(); mapa.scrollWheelZoom.disable(); }
        },
        pino: (lat, lng, aoSoltar) => {
            if (marcador) {
                marcador.setLatLng([lat, lng]);
                return;
            }
            marcador = L.marker([lat, lng], {
                icon: iconePino,
                draggable: true,
                keyboard: true,
                title: TITULO_PINO,
            }).addTo(mapa);
            marcador.on('dragend', () => {
                const p = marcador.getLatLng();
                aoSoltar(p.lat, p.lng);
            });
        },
        destruir: () => mapa.remove(),
    };
};

export const criarMotorGoogle = (maps, no, { centro, zoom, aoClicar }) => {
    const mapa = new maps.Map(no, {
        center: { lat: centro[0], lng: centro[1] },
        zoom,
        gestureHandling: 'none',
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: { position: maps.ControlPosition.LEFT_BOTTOM },
        clickableIcons: false,
    });

    mapa.addListener('click', (e) => aoClicar(e.latLng.lat(), e.latLng.lng()));

    let marcador = null;

    return {
        tipo: 'google',
        redimensionar: () => {},
        centralizar: (lat, lng, z, animar = true) => {
            mapa.setZoom(z);
            if (animar) mapa.panTo({ lat, lng });
            else mapa.setCenter({ lat, lng });
        },
        zoom: () => mapa.getZoom(),
        arrasto: (solto) => mapa.setOptions({ gestureHandling: solto ? 'greedy' : 'none' }),
        pino: (lat, lng, aoSoltar) => {
            if (marcador) {
                marcador.setPosition({ lat, lng });
                return;
            }
            marcador = new maps.Marker({
                position: { lat, lng },
                map: mapa,
                draggable: true,
                title: TITULO_PINO,
                icon: {
                    path: 'M12 0C7.03 0 3 4.03 3 9c0 6.75 9 15 9 15s9-8.25 9-15c0-4.97-4.03-9-9-9z',
                    fillColor: COR_PINO,
                    fillOpacity: 1,
                    strokeColor: '#ffffff',
                    strokeWeight: 2,
                    scale: 1.5,
                    anchor: new maps.Point(12, 24),
                },
            });
            marcador.addListener('dragend', (e) => aoSoltar(e.latLng.lat(), e.latLng.lng()));
        },
        destruir: () => {
            if (marcador) marcador.setMap(null);
            maps.event.clearInstanceListeners(mapa);
        },
    };
};

export const criarMotor = (no, opcoes, pronto) => {
    const chave = chaveGoogleMaps();
    if (!chave) {
        pronto(criarMotorLeaflet(no, opcoes));
        return;
    }

    carregarGoogleMaps(chave)
        .then((maps) => {
            const motor = criarMotorGoogle(maps, no, opcoes);
            window.gm_authFailure = () => {
                motor.destruir();
                no.innerHTML = '';
                pronto(criarMotorLeaflet(no, opcoes));
            };
            pronto(motor);
        })
        .catch(() => pronto(criarMotorLeaflet(no, opcoes)));
};
